<template>
  <div class="">
    <div class="about-container">
      <div class="container about-box">
        <hometitle :title="aboutTitle" :subtitle="aboutSubTitle"
          :class='isAbout?"d-none":""'
        ></hometitle>
          <div style="text-align: center;">
              <h3 class="about-title">{{aboutData.name}}</h3>
              <span class="about-cross"></span>
              <p class="about-text ">{{aboutData.body}}</p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import HoemTitle from '../components/HomeTitle'
import aboutCN from '../data/CN/about_CN.json'
import aboutEN from '../data/EN/about_EN.json'
import aboutJP from '../data/JP/about_JP.json'
export default {
  props: {
    isAbout: { type: Boolean }
  },
  data() {
    return {
      aboutTitle: '关于光维',
      aboutSubTitle: 'About Us',
      currentLanguage: "",
      aboutData: {}
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              _this.currentLanguage = e.newValue
              var d = e.newValue
              if (d === 'CN') {
                  _this.aboutData = aboutCN
              } else if (d === 'EN') {
                  _this.aboutData = aboutEN
              } else if (d === 'JP') {
                  _this.aboutData = aboutJP
              }
          }
      })
  },
  methods: {
    findAbout: async function() {
      //const res = await this.$http.get('introduce')
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
      if (lg === 'CN') {
          this.aboutData = aboutCN
      } else if (lg === 'EN') {
          this.aboutData = aboutEN
      } else if (lg === 'JP') {
          this.aboutData = aboutJP
      }
      
    }
  },
  created() {
    this.findAbout()
  },
  components: {
    hometitle: HoemTitle
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .about-title {
    font-size: 24px;
  }
  .about-text {
    font-size: 14px;
  }
  .about-swiper {
    margin-top: 40px !important;
  }
}
.about-container {
  padding-top: 40px;
  width: 100%;
  background: url(../assets/image/home-about-bg.png) center no-repeat;
}
.about-box {
  height: 100%;
  padding-bottom: 40px;
}
.about-swiper {
  text-align: center;
  height: 260px;
  margin-top: 60px;
}
.about-title {
  color: #048bd4;
  /* font-family: 'myfont'; */
}
.about-cross {
  display: inline-block;
  margin: 10px 0;
  width: 40px;
  height: 3px;
  background-color: #f15500;
}
.about-text {
  width: 100%;
  font-size: 16px;
  color: #666;
  line-height: 32px;
}
.about-swiper-pagination {
  position: absolute;
  bottom: 10px;
}
</style>